import { render } from "./customer-ar.vue?vue&type=template&id=a14b013e"
import script from "./customer-ar.vue?vue&type=script&lang=js"
export * from "./customer-ar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__